<template>
    <div class="lang">
        <div class="info">
            <div class="table">
                <table>
                    <caption>结果 (如需就诊咨询, 如果您选择邮寄咨询结果, 如果您选择在线查看结果)</caption>
                    <colgroup>
                        <col style="width: 25%">
                        <col>
                    </colgroup>
                    <tbody>
                        <tr>
                            <th scope="row">如需就诊咨询</th>
                            <td class="left">
                                可按预约的就诊时间和日期前往健康促进中心就诊. <br>
                                如在就诊咨询中有任何发现，我们会将您转诊至相关科室.
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">如果您选择邮寄咨询结果</th>
                            <td class="left">
                                咨询结果会根据您预定的咨询日期寄送，结果会在三个工作天内通过挂号邮件送达. <br>
                                在寄送结果之前, 您将收到我们的护士打来的愉快电话, 如果根据检查结果认为有必要, 将引导您到门诊就诊.
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">如果您选择在线查看结果</th>
                            <td class="left">
                                在预定咨询日期之后注册, 然后您可以在梨花女子大学首尔医院健康促进中心网站的"我的页面"上的"[查看结果]"下找到结果.
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="botton-wrap"><a href="/" class="main-button c-main">View Result</a></div>
        </div>
    </div>
</template>
<script>
export default {

}
</script>